export type Categories = "GDPR" | "sms" | "email" | "post" | "additional" | "survey" | "all";
export type Steps =
  "registration" | "dashboard" | "subscription" | "contact_form" | "set_password" | "all" | "quiz" | "sob";
export type OtPurposesByCategoryAndUser = OtPurposeByCategory & OtPurposeByUUID;
export type OtPurposesByStepsAndUser = OtPurposeBySteps & OtPurposeByUUID;
export type OtPurposesByContextAndUser = EvoOtPurpose & OtPurposeByUUID;
export type CategoryGroupedPurposes = {
  category: Categories;
  purposes: (OtPurposeByUUID & OtPurposeByCategory)[];
};
export type SectionGroupedPurposes = {
  sectionName: string;
  sectionId: string;
  sectionDescription: string | null;
  category: Categories;
  purposes: (OtPurposeByUUID & OtPurposeByCategory)[];
};
export type SpecificSteps = Exclude<Steps, "all">;
export type SpecificCategories = Exclude<Categories, "all">;
export type SpecificContext = Exclude<Steps | Categories, "all">;

export interface OtPurpose {
  id: string;
  name: string;
  description: string;
  language: string;
  mandatory: boolean;
  default: boolean;
  created_at?: string | null;
  revokes_at?: string | null;

  section: {
    id: string;
    name: string;
    description: string | null;
  };
}

export interface OtPurposeBySteps extends OtPurpose {
  step: SpecificSteps;
}

export interface OtPurposeByCategory extends OtPurpose {
  category: SpecificCategories;
}

export interface OtPurposeByUUID extends OtPurpose {
  accepted: boolean;
  one_off?: boolean;
}

export interface EvoOtPurpose extends OtPurpose {
  context: SpecificContext;
  accepted: boolean;
}

export type PurposeGrouping = "category" | "section";

export type AcceptAllButtonMode = "none" | "optional";

export type GroupedPurposes = {
  purposeTitle: string;
  purposeDescription?: string | null;
  purposeId: string;
  category: Categories;
  purposes: (OtPurposeByUUID & OtPurposeByCategory & { purposeName: string; purposeDescription: string })[];
};

export type GroupedByCategoryPurposeDescriptions = Record<Categories, string | undefined>;

type CustomAttributeValues = Record<string, unknown>;

export type UserConsentUpdatedUser = {
  uuid: string;
  email: string;
  phone: string;
  first_name: string;
  last_name: string;
  date_of_birth: string;
  age_verification_uuid: any;
  custom_attributes: CustomAttributeValues;
  gender: any;
  referral_code: any;
  addresses: any[];
  source: any[];
  tracking: null;
  statusCode?: number;
};
